const API_ROOT = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:3002/').replace(/\/?$/, '/');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('tenantId') || localStorage.getItem('tenant_id');
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(tenantId && { 'X-Tenant-Id': tenantId }),
  };
};

const base = `${API_ROOT}synctrack/app-config`;

async function parseJson(res, fallbackMsg) {
  if (!res.ok) {
    let msg = fallbackMsg || `Request failed (${res.status})`;
    try {
      const body = await res.json();
      if (body?.message) msg = body.message;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export async function fetchEffectiveAppConfig(tenantId) {
  const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  const res = await fetch(`${base}${qs}`, { headers: getAuthHeaders() });
  const data = await parseJson(res, 'Failed to load app config');
  return Array.isArray(data) ? data : [];
}

export async function fetchGlobalAppConfig() {
  const res = await fetch(`${base}/global`, { headers: getAuthHeaders() });
  const data = await parseJson(res, 'Failed to load global app config');
  return Array.isArray(data) ? data : [];
}

export async function saveTenantAppConfig(key, body, tenantId) {
  const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  const res = await fetch(`${base}/${encodeURIComponent(key)}${qs}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return parseJson(res, 'Failed to save app config');
}

export async function saveGlobalAppConfig(key, body) {
  const res = await fetch(`${base}/global/${encodeURIComponent(key)}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return parseJson(res, 'Failed to save global app config');
}

export async function syncAppConfigFromGlobal(tenantId) {
  const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  const res = await fetch(`${base}/sync-from-global${qs}`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return parseJson(res, 'Failed to sync from global');
}
